// Source: https://github.com/vinted/dwh-schema-registry/blob/5387d2ce7b44ee93711a15dfb97c60a4d984f22c/avro/events/common/shared/user.avdl#L25
type UserTarget = 'upload_more_cancel' | 'upload_more_accept' | 'close_screen'

type ClickEventArgs = {
  target: UserTarget
  screen?: string | null
  targetDetails?: string | null
  path?: string | null
  env?: string | null
}

type ClickEventExtra = {
  target: UserTarget
  screen?: string
  target_details?: string
  path?: string | null
  env?: string | null
}

export const clickEvent = (args: ClickEventArgs) => {
  const { target, screen, targetDetails, env, path } = args
  const extra: ClickEventExtra = { target }

  if (screen) extra.screen = screen

  if (targetDetails) extra.target_details = targetDetails

  if (env) extra.env = env

  if (path) extra.path = path

  return {
    event: 'user.click',
    extra,
  }
}

type ViewScreenEventArgs = {
  screen: string
}

export const viewScreenEvent = (args: ViewScreenEventArgs) => {
  const { screen } = args

  const extra = {
    screen,
  }

  return {
    event: 'user.view_screen',
    extra,
  }
}

type ItemUploadViewScreenEventArgs = {
  screen: string
  details?: string
  uploadSessionId: string | null
}

type ItemUploadViewScreenEventExtra = {
  screen: string
  details?: string
  upload_session_id: string | null
}

export const itemUploadViewScreenEvent = (args: ItemUploadViewScreenEventArgs) => {
  const { screen, details, uploadSessionId } = args

  const extra: ItemUploadViewScreenEventExtra = {
    screen,
    upload_session_id: uploadSessionId,
  }

  if (details) extra.details = details

  return {
    event: 'upload_form.user.view_screen',
    extra,
  }
}
